// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".material-notification[data-v-38afa62d]{display:flex;flex-direction:column-reverse;align-items:flex-end;position:fixed;top:0;right:0;left:0;width:auto;height:auto;z-index:2147483647}.material-notification span[data-v-38afa62d]:first-child{width:100%}.material-notification .material-notification__item[data-v-38afa62d]{display:flex;align-items:center;justify-content:space-between;position:relative;top:0;width:100%;padding:12px;z-index:2147483647}\n", ""]);
// Exports
module.exports = exports;
